import * as React from "react";

const SvgHeavySleetSun = (props) => (
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <clipPath clipPathUnits="userSpaceOnUse" id="HeavySleetSun_svg__a">
        <path d="M766.19 404.905c0-7.16 5.803-12.963 12.962-12.963 7.16 0 12.964 5.803 12.964 12.963 0 7.159-5.804 12.963-12.964 12.963-7.159 0-12.962-5.804-12.962-12.963" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="HeavySleetSun_svg__b">
        <path d="M0 943.388h1828.656V0H0Z" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="HeavySleetSun_svg__c">
        <path d="M1376.881 707.171c-.053.001-.105.004-.158.004a8.288 8.288 0 0 1-8.288-8.288 8.287 8.287 0 0 1 8.288-8.287h20.599a6.697 6.697 0 0 1 0 13.393c-.023 0-.046-.004-.068-.004-.596 5.34-5.123 9.492-10.622 9.492-4.343 0-8.078-2.591-9.751-6.31" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="HeavySleetSun_svg__d">
        <path d="m1348.684 682.253-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="HeavySleetSun_svg__e">
        <path d="m1359.325 682.253-10-17.32a2 2 0 0 1 .733-2.732 1.998 1.998 0 0 1 2.731.732l10 17.32a2 2 0 0 1-.732 2.733 2.002 2.002 0 0 1-2.732-.733" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="HeavySleetSun_svg__f">
        <path d="m1380.107 682.253-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="HeavySleetSun_svg__g">
        <path d="m1370.216 682.253-8-13.855a2.002 2.002 0 0 1 .731-2.733 1.998 1.998 0 0 1 2.733.733l8 13.855c.552.957.224 2.18-.732 2.733a1.999 1.999 0 0 1-2.732-.733" />
      </clipPath>
    </defs>
    <g
      clipPath="url(#HeavySleetSun_svg__a)"
      transform="matrix(1.33333 0 0 -1.33333 -974.87 559.814)"
      style={{
        fill: "#ffc624",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#ffc624",
          fillOpacity: 1,
        }}
      >
        <path
          d="M766.19 404.905c0-7.16 5.803-12.963 12.962-12.963 7.16 0 12.964 5.803 12.964 12.963 0 7.159-5.804 12.963-12.964 12.963-7.159 0-12.962-5.804-12.962-12.963"
          style={{
            fill: "#ffc624",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#HeavySleetSun_svg__b)"
      style={{
        fill: "#647179",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -1779.413 977.92)"
    >
      <g
        style={{
          fill: "#647179",
          fillOpacity: 1,
        }}
      >
        <path
          d="M0 0c5.889 0 10.664 4.774 10.664 10.664 0 5.889-4.775 10.664-10.664 10.664-.037 0-.073-.006-.109-.006-.949 8.504-8.158 15.116-16.915 15.116-6.916 0-12.864-4.125-15.528-10.048-.085.002-.168.006-.253.006-7.289 0-13.198-5.909-13.198-13.198C-46.003 5.909-40.094 0-32.805 0"
          style={{
            fill: "#647179",
            fillOpacity: 1,
            fillRule: "nonzero",
            stroke: "none",
          }}
          transform="translate(1383.105 690.6)"
        />
      </g>
    </g>
    <g
      clipPath="url(#HeavySleetSun_svg__c)"
      style={{
        fill: "#daebf9",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -1779.413 977.92)"
    >
      <g
        style={{
          fill: "#daebf9",
          fillOpacity: 1,
        }}
      >
        <path
          d="M1376.881 707.171c-.053.001-.105.004-.158.004a8.288 8.288 0 0 1-8.288-8.288 8.287 8.287 0 0 1 8.288-8.287h20.599a6.697 6.697 0 0 1 0 13.393c-.023 0-.046-.004-.068-.004-.596 5.34-5.123 9.492-10.622 9.492-4.343 0-8.078-2.591-9.751-6.31"
          style={{
            fill: "#daebf9",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#HeavySleetSun_svg__d)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -1779.413 975.92)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="m1348.684 682.253-6.499-11.256a2 2 0 0 1 .732-2.732 1.998 1.998 0 0 1 2.732.732l6.499 11.256c.552.957.224 2.18-.732 2.733a2 2 0 0 1-2.732-.733"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#HeavySleetSun_svg__e)"
      style={{
        fill: "#daebf9",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -1779.413 975.92)"
    >
      <g
        style={{
          fill: "#daebf9",
          fillOpacity: 1,
        }}
      >
        <path
          d="m1359.325 682.253-10-17.32a2 2 0 0 1 .733-2.732 1.998 1.998 0 0 1 2.731.732l10 17.32a2 2 0 0 1-.732 2.733 2.002 2.002 0 0 1-2.732-.733"
          style={{
            fill: "#daebf9",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#HeavySleetSun_svg__f)"
      style={{
        fill: "#daebf9",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -1779.413 975.92)"
    >
      <g
        style={{
          fill: "#daebf9",
          fillOpacity: 1,
        }}
      >
        <path
          d="m1380.107 682.253-6.001-10.391a2 2 0 0 1 1.73-3.001c.691 0 1.365.359 1.735 1l5.999 10.392a2 2 0 0 1-.732 2.733 1.997 1.997 0 0 1-2.731-.733"
          style={{
            fill: "#daebf9",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#HeavySleetSun_svg__g)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
      transform="matrix(1.33333 0 0 -1.33333 -1779.413 975.92)"
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="m1370.216 682.253-8-13.855a2.002 2.002 0 0 1 .731-2.733 1.998 1.998 0 0 1 2.733.733l8 13.855c.552.957.224 2.18-.732 2.733a1.999 1.999 0 0 1-2.732-.733"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <path
      style={{
        opacity: 0.996721,
        fill: "none",
        strokeWidth: 0.878738,
        strokeLinejoin: "round",
        paintOrder: "stroke fill markers",
      }}
      transform="matrix(1.33333 0 0 1.33333 672 -54.15)"
      d="M-504 40.612h72v72h-72z"
    />
  </svg>
);

export default SvgHeavySleetSun;
